import type { IContainer } from '../../interface/container';
import { injectFetch } from '../../interface/util';
import { injectConfigAPI } from '../../interface/config';
import type { IMediumDiffRequestStatus } from '../interface';
import type { IMediaDiffAPI } from '../interface/mediaDiff';
import getMediaDiff from './mediaDiff';

function mediaDiff(container: IContainer): IMediaDiffAPI {
    const fetcher = injectFetch(container);
    const config = injectConfigAPI(container);

    const module: IMediaDiffAPI = {
        getMediaDiff: (
            authToken: string,
            siteId: number,
            siteHash = '',
            existingMedia: Array<IMediumDiffRequestStatus> = [],
        ) => getMediaDiff(fetcher, config, authToken, siteId, siteHash ?? '', existingMedia ?? []),
    };

    return module;
}

export default mediaDiff;
